import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialBookingDetails } from '../initialState'
import bookingDetailsAction from './bookingDetailsAction'

const bookingDetailsSlice = createSlice({
  name: 'bookingDetails',
  initialState: initialBookingDetails,
  reducers: {
    updateNote: (state: any, action: PayloadAction<any>) => {
      if (action.payload.type === 'destinationAddresses') state.destinationAddresses[0].note = action.payload.value
      else state[action.payload.type].note = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder.addCase(bookingDetailsAction.getBookingDetails.fulfilled, (state, action: PayloadAction<any>) => {
      if (!action.payload) return
      return action.payload
    })
  },
})

export const bookingDetailsActions = bookingDetailsSlice.actions
export default bookingDetailsSlice
